export default __webpack_public_path__ + "static/media/Snd_TryQ.1f48c658.mp3";